<template>
  <PopDialog
    title="영역 정보 수정"
    :visible="props.visible"
    :okCallback="onOkClick"
    :cancelCallback="onCancelClick"
  >
    <input
      type="text"
      class="form-control form-control-lg fs-15px"
      placeholder="영역 이름을 입력해주세요."
      v-model="modifiedZoneName"
    />
  </PopDialog>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import PopDialog from '@/common/components/popup/PopDialog.vue';

const props = defineProps([
  'visible',
  'okCallback',
  'cancelCallback',
  'zoneName',
]);
let modifiedZoneName = ref(props.zoneName);

const onOkClick = () => {
  if (props.okCallback) {
    props.okCallback(modifiedZoneName.value);
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};
</script>
